module.exports = __webpack_public_path__ + "img/img3.4079ca5d.png";